<template>
  <div class="base-info">
    <a-form-model ref="ruleForm" :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
                  :model="ruleForm" :rules="rules">
      <a-card :bordered="false" title="公司信息" :headStyle="{paddingLeft:'0px'}">
        <a-form-model-item label="公司名称" prop="companyName">
          <a-input placeholder="公司名称" v-model="ruleForm.companyName" style="width: 350px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="统一社会信用代码" prop="socialCreditCode">
          <a-input :maxLength="18" placeholder="请输入统一社会信用代码" v-model="ruleForm.socialCreditCode"
                   style="width: 350px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="公司类型">
          <a-select v-model="ruleForm.companyType" style="width: 350px">
            <a-select-option :value="0">
              请选择
            </a-select-option>
            <a-select-option :value="1">
              有限责任公司
            </a-select-option>
            <a-select-option :value="2">
              股份有限公司
            </a-select-option>
            <a-select-option :value="3">
              个体工商户
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="经营范围">
          <a-textarea
            v-model="ruleForm.companyBusiness"
            placeholder="请输入经营范围"
            style="max-width: 350px"
            :rows="6"
          ></a-textarea>
        </a-form-model-item>
        <a-form-model-item label="公司注册地址">
          <a-cascader
            style="max-width: 350px;"
            :options="provinceList"
            @change="onCityChange"
            :value='defaultValue'
            placeholder="请选择所在省市城市"
          />
        </a-form-model-item>
        <a-form-model-item label=" " :colon="false" :required="false">
          <a-input v-model="ruleForm.companyRegFullAddress" placeholder="请输入详细地址" style="width: 350px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="公司经营地址" prop="companyRunArr">
          <a-cascader
            v-model="ruleForm.companyRunArr"
            style="max-width: 350px;"
            :options="provinceList"
            @change="companyRunChange"
            :value='companyRunArdefaultValue'
            placeholder="请选择所在省市城市"
          />
        </a-form-model-item>
        <a-form-model-item label=" " :colon="false" :required="false">
          <a-input v-model="ruleForm.companyRunFullAddress" placeholder="请输入详细地址" style="width: 350px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="营业执照" :required="false">
          <div class="upload-box">
            <a-upload
              v-model="ruleForm.companyLicence"
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              listType="picture-card"
              @change="fileInfo=>handleChange(fileInfo,1)"
              :before-upload="handleBeforeUploadImage"
            >
              <img style="width: 80px;height: 80px" v-if="ruleForm.companyLicence" :src="ruleForm.companyLicence"
                   alt="avatar" class="image"/>
              <div v-else>
                <a-icon :type="uploading? 'loading' : 'plus'"/>
              </div>
            </a-upload>
          </div>
        </a-form-model-item>
      </a-card>
      <a-card :bordered="false" title="法定代表人信息">
        <a-form-model-item label="法定代表人姓名" prop="companyLegalName">
          <a-input placeholder="请输入" v-model="ruleForm.companyLegalName" style="width: 350px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="身份证号" prop="companyLegalIdCard">
          <a-input placeholder="请输入" v-model="ruleForm.companyLegalIdCard" style="width: 350px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="身份证有效期" :required="false" prop="companyLegalValidTime">
          <a-date-picker style="width: 350px" placeholder="请选择" format="YYYY-MM-DD"
                         v-model="ruleForm.companyLegalValidTime"/>
          <a-checkbox style="margin-left: 10px" v-model="ruleForm.companyLegalValidStatus">长期</a-checkbox>
        </a-form-model-item>
        <a-form-model-item label="身份证人像面" prop="companyLegalCredential">
          <div class="upload-box">
            <a-upload
              v-model="ruleForm.companyLegalCredential"
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              listType="picture-card"
              @change="fileInfo=>handleChange(fileInfo,2)"
              :before-upload="handleBeforeUploadImage"
            >
              <img v-if="ruleForm.companyLegalCredential" :src="ruleForm.companyLegalCredential" alt="avatar"
                   class="selected-image"/>
              <div v-else>
                <a-icon type="plus"/>
              </div>
            </a-upload>
            <img src="https://imgb.woyoubooking.com/common/person_card.jpg"
                 :class="[ruleForm.companyLegalCredential?'image-sample':'image-sample-1']">
          </div>
        </a-form-model-item>
        <a-form-model-item label="身份证国徽面" :required="false" prop="companyLegalCredentialBack">
          <div class="upload-box">
            <a-upload
              v-model="ruleForm.companyLegalCredentialBack"
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              listType="picture-card"
              @change="fileInfo=>handleChange(fileInfo,3)"
              :before-upload="handleBeforeUploadImage"
            >
              <img v-if="ruleForm.companyLegalCredentialBack" :src="ruleForm.companyLegalCredentialBack" alt="avatar"
                   class="selected-image"/>
              <div v-else>
                <a-icon type="plus"/>
              </div>
            </a-upload>
            <img src="https://imgb.woyoubooking.com/common/nation_card.jpg"
                 :class="[ruleForm.companyLegalCredentialBack?'image-sample':'image-sample-1']">
          </div>
        </a-form-model-item>
      </a-card>
      <a-card :bordered="false" title="管理人信息">
        <a-form-model-item label="管理人姓名" prop="companyAdminName">
          <a-input placeholder="请输入" v-model="ruleForm.companyAdminName" style="width: 350px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="身份证号" prop="companyAdminIdCard">
          <a-input v-model="ruleForm.companyAdminIdCard" placeholder="请输入" style="width: 350px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="身份证有效期" :required="false" prop="companyAdminValidTime">
          <a-date-picker style="width: 350px" placeholder="请选择" format="YYYY-MM-DD"
                         v-model="ruleForm.companyAdminValidTime"/>
          <a-checkbox style="margin-left: 10px" v-model="ruleForm.companyAdminValidStatus">长期</a-checkbox>
        </a-form-model-item>
        <a-form-model-item label="身份证人像面" prop="companyAdminCredential">
          <div class="upload-box">
            <a-upload
              v-model="ruleForm.companyAdminCredential"
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              listType="picture-card"
              @change="fileInfo=>handleChange(fileInfo,4)"
              :before-upload="handleBeforeUploadImage"
            >
              <img v-if="ruleForm.companyAdminCredential" :src="ruleForm.companyAdminCredential" alt="avatar"
                   class="selected-image"/>
              <div v-else>
                <a-icon type="plus"/>
              </div>
            </a-upload>
            <img src="https://imgb.woyoubooking.com/common/person_card.jpg"
                 :class="[ruleForm.companyAdminCredential?'image-sample':'image-sample-1']">
          </div>
        </a-form-model-item>
        <a-form-model-item label="身份证国徽面" prop="companyAdminCredentialBack">
          <div class="upload-box">
            <a-upload
              v-model="ruleForm.companyAdminCredentialBack"
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              listType="picture-card"
              @change="fileInfo=>handleChange(fileInfo,5)"
              :before-upload="handleBeforeUploadImage"
            >
              <img v-if="ruleForm.companyAdminCredentialBack" :src="ruleForm.companyAdminCredentialBack" alt="avatar"
                   class="selected-image"/>
              <div v-else>
                <a-icon type="plus"/>
              </div>
            </a-upload>
            <img src="https://imgb.woyoubooking.com/common/nation_card.jpg"
                 :class="[ruleForm.companyAdminCredentialBack?'image-sample':'image-sample-1']">
          </div>
        </a-form-model-item>

        <a-form-model-item label=" " :colon="false" :required="false">
          <a-button type="primary" @click="saveEvent" :loading="saveLoading" style="width:100px;">保存</a-button>
        </a-form-model-item>
      </a-card>
    </a-form-model>
  </div>
</template>

<script>
import formMixins from '../../../utils/mixins/formMixins'
import moment from 'moment'

export default {
  name: 'SubjectInfoComponents',
  mixins: [formMixins],
  data() {
    return {
      businessFileList: [],
      currentFormLayout: {
        labelCol: {
          xxl: { span: 2 },
          xl: { span: 4 },
          lg: { span: 5 },
          sm: { span: 6 },
          md: { span: 9 },
          xs: { span: 12 }
        },
        wrapperCol: {
          xxl: { span: 22 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 20 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 19 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 18 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 15 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 12 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      ruleForm: {
        companyName: '',// 商户公司名称 ,
        socialCreditCode: '',// 社会信用代码
        companyType: 0,// 商户公司类型 1.有限责任公司、2.股份有限公司、3.个体工商户 ,
        companyBusiness: '',// 商户公司业务 ,
        companyRegAreaId: '',// 商户公司注册区 ,
        companyRegCityId: '',// 商户公司注册市
        companyRegProvinceId: '',// 商户公司注册省 ,
        companyRegFullAddress: '',// 商户公司注册详细地址 ,
        companyRunArr: [],//公司经营地址集合
        companyRunAreaId: '',// 商户公司经营区 ,
        companyRunCityId: '',// 商户公司经营市 ,
        companyRunProvinceId: '',// 商户公司经营省 ,
        companyRunFullAddress: '',// 商户公司经营详细地址 ,
        companyLicence: null,// 商户公司营业执照 ,
        companyLegalName: '',// 商户公司法人名称 ,
        companyLegalIdCard: '',// 商户公司法人证件号 ,
        companyLegalValidStatus: false,// 商户公司法人证件有效类型 0：非长期 1：长期 ,
        companyLegalValidTime: null,// 商户公司法人证件有效期 ,
        companyLegalCredential: '',// 商户公司法人身份证正面照 ,
        companyLegalCredentialBack: '',// 商户公司法人身份证背面照 ,
        companyAdminIdCard: '',// 商户管理员证件号 ,
        companyAdminName: '',// 商户管理员名称 ,
        companyAdminValidStatus: false,// 商户管理员身份证有效类型0：非长期，1：长期 ,
        companyAdminValidTime: null,// 商户管理员身份证有效期 ,
        companyAdminCredential: '',// 商户管理员证件正面照 ,
        companyAdminCredentialBack: ''// 商户管理员证件背面照 ,
      },
      rules: {
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        socialCreditCode: [
          { required: true, message: '请输入社会信用代码', trigger: 'blur' }
        ],
        companyRunArr: [
          { required: true, message: '请选择公司经营地址', trigger: 'blur' }
        ],
        companyLicence: [
          { required: true, message: '请上传公司营业执照', trigger: 'blur' }
        ],
        companyLegalName: [
          { required: true, message: '请输入法人代表姓名', trigger: 'blur' }
        ],
        companyLegalIdCard: [
          { required: true, type: 'string', message: '请输入法人身份证号', trigger: 'blur' }
        ],
        // companyLegalValidTime: [
        //   { required: true, message: '请选择法人身份证有效期', trigger: 'blur' }
        // ],
        companyLegalCredential: [
          { required: true, message: '请上传法人身份证正面', trigger: 'blur' }
        ],
        companyLegalCredentialBack: [
          { required: true, message: '请上传法人身份证背面', trigger: 'blur' }
        ],
        companyAdminName: [
          { required: true, message: '请输入管理人姓名', trigger: 'blur' }
        ],
        companyAdminIdCard: [
          { required: true, type: 'string', message: '请输入管理人身份证号', trigger: 'blur' }
        ],
        // companyAdminValidTime: [
        //   { required: true, message: '请选择管理人身份证有效期', trigger: 'blur' }
        // ],
        companyAdminCredential: [
          { required: true, message: '请上传管理人身份证正面', trigger: 'blur' }
        ],
        companyAdminCredentialBack: [
          { required: true, message: '请上传管理人身份证背面', trigger: 'blur' }
        ]
      },
      provinceList: [],
      defaultValue: [],
      companyRunArdefaultValue: [],
      uploadFileUrl: this.getAppConfig().baseUrl + 'base/upload',
      uploading: false
    }
  },
  mounted() {
    this.getDetail()
    this.getProvinceList()
  },
  methods: {
    getDetail() {
      let params = {
        merchantId: this.$store.getters.userInfo.merchantId
      }
      this.getHttpServices().getUserService().get('api/v2/merchant/main/detail', params)
        .then(res => {
          if (res) {
            this.ruleForm = res
            this.ruleForm.companyLegalValidStatus = res.companyLegalValidStatus == 1 ? true : false,// 商户公司法人证件有效类型 0：非长期 1：长期 ,
              this.ruleForm.companyLegalValidTime = res.companyLegalValidTime ? moment(res.companyLegalValidTime, 'YYYY-MM-DD') : null,// 商户公司法人证件有效期 ,
              this.ruleForm.companyAdminValidStatus = res.companyAdminValidStatus == 1 ? true : false,// 商户管理员身份证有效类型0：非长期，1：长期 ,
              this.ruleForm.companyAdminValidTime = res.companyAdminValidTime ? moment(res.companyAdminValidTime, 'YYYY-MM-DD') : null,// 商户管理员身份证有效期 ,
              this.ruleForm.companyRunArr = [res.companyRunProvinceId, res.companyRunCityId, res.companyRunAreaId]  //公司经营地址集合
            this.companyRunArdefaultValue = [res.companyRunProvinceId, res.companyRunCityId, res.companyRunAreaId]
            this.defaultValue = [res.companyRegProvinceId, res.companyRegCityId, res.companyRegAreaId]
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getProvinceList() { //获取地址
      this.getHttpServices().getBaseService().get('province/getProvinceCityCounty').then(res => {
        this.provinceList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onCityChange(value) { //地址修改
      if (value && value.length) {
        this.ruleForm.companyRegAreaId = value[2]// 商户公司注册区 ,
        this.ruleForm.companyRegCityId = value[1]// 商户公司注册市
        this.ruleForm.companyRegProvinceId = value[0]// 商户公司注册省 ,
        this.defaultValue = [value[0], value[1], value[2]]
      }
    },
    companyRunChange(value) { //地址修改
      if (value && value.length) {
        this.ruleForm.companyRunAreaId = value[2]// 商户公司经营区 ,
        this.ruleForm.companyRunCityId = value[1]//商户公司经营市 ,
        this.ruleForm.companyRunProvinceId = value[0]// 商户公司经营省 ,
        this.companyRunArdefaultValue = [value[0], value[1], value[2]]
        this.ruleForm.companyRunArr = [value[0], value[1], value[2]]
      }
    },
    //文件变更监听
    handleChange(fileInfo, index) {
      if (fileInfo.file.status === 'uploading') {
        this.uploading = true
      } else if (fileInfo.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(fileInfo.fileList)
        if (index == 1) {
          this.ruleForm.companyLicence = url//上传后的图片地址
        } else if (index == 2) {
          this.ruleForm.companyLegalCredential = url
        } else if (index == 3) {
          this.ruleForm.companyLegalCredentialBack = url
        } else if (index == 4) {
          this.ruleForm.companyAdminCredential = url
        } else {
          this.ruleForm.companyAdminCredentialBack = url
        }
        this.uploading = false
      }
    },
    handleBusinessLicenseChange() {

    },
    saveEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitData() {
      if (this.ruleForm.socialCreditCode.length != 18) {
        this.$message.warn('统一社会信用代码，必须18个字符')
        return
      }
      if (!this.ruleForm.companyLegalValidStatus && !this.ruleForm.companyLegalValidTime) {
        this.$message.warn('请选择法定代表证件有效期')
        return
      }
      if (!this.ruleForm.companyAdminValidStatus && !this.ruleForm.companyAdminValidTime) {
        this.$message.warn('请选择商户管理员身份证有效期')
        return
      }
      if (!this.ruleForm.companyLicence) {
        this.$message.warn('请上传营业执照')
        return
      }
      let companyLegalValidTime = this.ruleForm.companyLegalValidTime ? this.ruleForm.companyLegalValidTime.format('YYYY-MM-DD') : ''
      let companyAdminValidTime = this.ruleForm.companyAdminValidTime ? this.ruleForm.companyAdminValidTime.format('YYYY-MM-DD') : ''
      let params = {
        companyName: this.ruleForm.companyName,// 商户公司名称 ,
        socialCreditCode: this.ruleForm.socialCreditCode,// 社会信用代码
        companyType: this.ruleForm.companyType,// 商户公司类型 1.有限责任公司、2.股份有限公司、3.个体工商户 ,
        companyBusiness: this.ruleForm.companyBusiness,// 商户公司业务 ,
        companyRegAreaId: this.ruleForm.companyRegAreaId,// 商户公司注册区 ,
        companyRegCityId: this.ruleForm.companyRegCityId,// 商户公司注册市
        companyRegProvinceId: this.ruleForm.companyRegProvinceId,// 商户公司注册省 ,
        companyRegFullAddress: this.ruleForm.companyRegFullAddress,// 商户公司注册详细地址 ,
        companyRunAreaId: this.ruleForm.companyRunAreaId,// 商户公司经营区 ,
        companyRunCityId: this.ruleForm.companyRunCityId,// 商户公司经营市 ,
        companyRunProvinceId: this.ruleForm.companyRunProvinceId,// 商户公司经营省 ,
        companyRunFullAddress: this.ruleForm.companyRunFullAddress,// 商户公司经营详细地址 ,
        companyLicence: this.ruleForm.companyLicence,// 商户公司营业执照 ,
        companyLegalName: this.ruleForm.companyLegalName,// 商户公司法人名称 ,
        companyLegalIdCard: this.ruleForm.companyLegalIdCard,// 商户公司法人证件号 ,
        companyLegalValidStatus: this.ruleForm.companyLegalValidStatus ? 1 : 0,// 商户公司法人证件有效类型 0：非长期 1：长期 ,
        companyLegalValidTime,// 商户公司法人证件有效期 ,
        companyLegalCredential: this.ruleForm.companyLegalCredential,// 商户公司法人身份证正面照 ,
        companyLegalCredentialBack: this.ruleForm.companyLegalCredentialBack,// 商户公司法人身份证背面照 ,
        companyAdminIdCard: this.ruleForm.companyAdminIdCard,// 商户管理员证件号 ,
        companyAdminName: this.ruleForm.companyAdminName,// 商户管理员名称 ,
        companyAdminValidStatus: this.ruleForm.companyAdminValidStatus ? 1 : 0,// 商户管理员身份证有效类型0：非长期，1：长期 ,
        companyAdminValidTime,// 商户管理员身份证有效期 ,
        companyAdminCredential: this.ruleForm.companyAdminCredential,// 商户管理员证件正面照 ,
        companyAdminCredentialBack: this.ruleForm.companyAdminCredentialBack,// 商户管理员证件背面照 ,
        companyTypeStr: this.ruleForm.companyTypeStr,// 公司类型字符串 ,
        id: this.ruleForm.id,
        merchantId: this.$store.getters.userInfo.merchantId
      }
      this.saveLoading = true
      this.getHttpServices().getUserService().post('api/v2/merchant/main/submit', params)
        .then(res => {
          this.$message.success('保存成功')
          //setTimeout(()=>this.backEvent(),500)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
    }
  }
}
</script>
<style lang="less" scoped>
.base-info {
  .upload-box {
    margin-top: 14px;
    height: 104px;
    position: relative;
  }

  .selected-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 180px;
    height: 104px;
  }

  .image-sample {
    position: absolute;
    top: 0;
    left: 200px;
    height: 104px;
    width: 180px;
  }

  .image-sample-1 {
    position: absolute;
    top: 0;
    left: 112px;
    height: 104px;
  }
}

</style>